import { supportService } from '../../services'
import { supportConstants } from '../constants'
import { request, success, failure } from './helper'

function getSuggestions() {
  return async dispatch => {
    dispatch(request(supportConstants.SUPPORT_REQUEST))
    try {
      const payload = await supportService.getSuggestions()
      dispatch(success(supportConstants.SUPPORT_SUCCESS, { payload }))
    } catch (error) {
      dispatch(failure(supportConstants.SUPPORT_FAILURE, error))
    }
  }
}

function setActiveSuggestion(index, keyword) {
  return dispatch => {
    dispatch(request(supportConstants.SUPPORT_SET_ACTIVE, { index, keyword }))
  }
}

export default {
  getSuggestions,
  setActiveSuggestion,
}
